<template>
    <div>
        <bv-top></bv-top>
        <card-detail>
            <van-cell class="addressCell" >房屋信息</van-cell>
            <template slot="content">
                <van-row type="flex" justify="space-between" class="content">
                    <van-col span="12" class="content-left">
                        房屋性质：{{houseInfo.houseProp}}
                    </van-col>
                    <van-col span="12" class="content-left">
                        房屋类型：{{houseInfo.houseType}}
                    </van-col>
                </van-row>
                <van-row type="flex" justify="space-between" class="content">
                    <van-col span="12" class="content-left">
                        建筑面积：{{houseInfo.constructAreaFormat}}m²
                    </van-col>
                    <van-col span="12" class="content-left">
                        交存模式：{{houseInfo.depositMode}}
                    </van-col>
                </van-row>
                <van-row type="flex" justify="space-between" class="content">
                    <van-col span="24" class="content-left">
                        承办银行：{{houseInfo.bankname}}
                    </van-col>
                </van-row>
                <van-row type="flex" justify="space-between" class="content">
                    <van-col span="12" class="content-left">
                        账户余额：{{houseInfo.balanceFormat}}元
                    </van-col>
                    <van-col span="12" class="content-left">
                        可用余额：{{houseInfo.usableAmountFormat}}元
                    </van-col>
                </van-row>
                <van-row type="flex" justify="space-between" class="content">
                    <van-col span="18" class="content-left">
                    </van-col>
                    <van-col span="6" style="color: #27B1F9" @click="houseTrade">
                        业务详情>>
                    </van-col>
                </van-row>
            </template>
        </card-detail>
        <card-detail>
            <van-cell class="addressCell" >业主信息</van-cell>
            <template slot="content">
                <van-row type="flex" justify="space-between" class="content">
                    <van-col span="12" class="content-left">
                        业主姓名：{{houseInfo.ownerName}}
                    </van-col>
                    <van-col span="12" class="content-left">
                        业主电话：{{houseInfo.phoneNo}}
                    </van-col>
                </van-row>
                <van-row type="flex" justify="space-between" class="content">
                    <van-col span="24" class="content-left">
                        身份证号：{{houseInfo.certNo}}
                    </van-col>
                </van-row>
            </template>
        </card-detail>
        <card-detail>
            <div :v-if="arcShareOwnerInfoList.length !== 0" :key="arcShareOwnerInfo.subAccount" v-for="arcShareOwnerInfo in arcShareOwnerInfoList">
                <van-cell class="addressCell" >共有人信息</van-cell>
                <div style="font-size: 12px">
                    <van-row type="flex" justify="space-between" class="content">
                        <van-col span="12" class="content-left">
                            共有人姓名：{{arcShareOwnerInfo.ownerName}}
                        </van-col>
                        <van-col span="12" class="content-left">
                            共有人电话：{{arcShareOwnerInfo.phoneNo}}
                        </van-col>
                    </van-row>
                    <van-row type="flex" justify="space-between" class="content">
                        <van-col span="24" class="content-left">
                            &nbsp;&nbsp;&nbsp;&nbsp;身份证号：{{arcShareOwnerInfo.certNo}}
                        </van-col>
                    </van-row>
                </div>
            </div>
        </card-detail>
    </div>
</template>

<script>
    import CardDetail from '@/components/card-detail.vue'
    import Top from '@/views/components/Top'
    import {houseInfo} from '@/api/maintainFund/maintainFund'
    export default {
        name: "HouseListInfo",
        data(){
          return{
              houseInfo:{},
              houseTradeList:[],
              arcShareOwnerInfoList:[]
          }
        },
        components:{
            BvTop:Top,
            CardDetail
        },
        mounted:function () {
            houseInfo(this.$route.query.param).then(res => {
                this.houseInfo = res.data.houseInfo;
                this.houseTradeList = res.data.houseTradeList;
                this.arcShareOwnerInfoList = res.data.houseInfo.arcShareOwnerInfoList
            });
        },
        methods:{
            houseTrade() {
                this.$router.push({path: '/maintainFund/houseTradeList', query: {label: '交易详情', param: this.houseTradeList}})
            },
        }
    }
</script>

<style lang="scss">
    .content{
        padding: 5px 0;
    }
    .content-left{
        color: #999;
    }
    .my-card-cell-group {
        border: 1px solid #ccc;
        border-radius: 8px;
        margin-top: 10px;
    }
    .card {
        background-color: #fbfbfb;
    }
    .addressCell {
        font-size: 16px;
        background-color: #eacd76;
        background-image: linear-gradient(90deg, #bbf0f9 20%, #fbfbfb 99%);
    }
</style>
